/**
 * pickInitialLanguage — choose the UI language for a fresh install, before any
 * stored preference loads.
 *
 * Agapella is a Russian-first product: most UI copy is authored in Russian and
 * only part of it is migrated to i18next. Auto-selecting English on an
 * English-locale phone therefore produced a broken RU/EN mix (CORE-573) — the
 * translated strings flipped to English while the hardcoded-Russian majority
 * stayed Russian. This is very common in РФ, where users keep the phone UI in
 * English.
 *
 * Policy (region-aware):
 *   - explicit Russian phone            → ru
 *   - any Russian-region phone (RU)     → ru   (even if its UI is English)
 *   - explicit Spanish phone            → es
 *   - everything else                   → ru   (the product default)
 *
 * English/Spanish stay reachable via the in-app Settings language switcher for
 * the surfaces that are fully translated.
 *
 * Kept as a pure function (input = expo-localization getLocales() output) so
 * the policy is unit-testable without importing the side-effectful i18n init.
 */
export type LocaleLike = { languageCode?: string | null; regionCode?: string | null };

export function pickInitialLanguage(locales: readonly LocaleLike[]): 'ru' | 'es' {
  const first = locales[0];
  if (first) {
    if (first.languageCode === 'ru') return 'ru';
    if (first.regionCode === 'RU') return 'ru';
    if (first.languageCode === 'es') return 'es';
  }
  return 'ru';
}
